import Routes from '@common/defs/routes';
import Help from '@mui/icons-material/Help';
import PersonSearch from '@mui/icons-material/PersonSearch';
import Contacts from '@mui/icons-material/Contacts';
import Settings from '@mui/icons-material/Settings';
import { SvgIconProps } from '@mui/material';
import { keyframes } from '@mui/system';
import { RocketLaunch } from '@mui/icons-material';

export const MAX_CONTENT_WIDTH = 1200 as const;
export const CONTENT_PADDING_X = { xs: 2, md: 5 } as const;
export const CONTENT_PADDING_Y = { xs: 3, md: 6 } as const;
export const TOPBAR_HEIGHT = 64 as const;
export const TOPBAR_TOP_MARGIN = 10 as const;
export const BOTTOMBAR_HEIGHT = 64 as const;

export const premiumGradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const premiumIconAnimation = keyframes`
  0% { color: #6366f1; }
  33% { color: #8b5cf6; }
  66% { color: #ec4899; }
  100% { color: #6366f1; }
`;

export interface MenuItem {
  icon: (props: SvgIconProps) => React.ReactNode;
  label: string;
  href: string;
  isActive: (path: string) => boolean;
  premium?: boolean;
  hideOnMobile?: boolean;
}

export const getNavigationItems = (
  user?: {
    hasActiveSx?: boolean;
    isDemo?: boolean;
    adsetId?: string;
    campaignsIds?: string[];
  } | null
): MenuItem[] => {
  const hasSystemX = user?.hasActiveSx || user?.isDemo;

  return [
    {
      icon: (props: SvgIconProps) => <PersonSearch {...props} />,
      label: 'Prospecter',
      href: Routes.Leads.Find,
      isActive: (path: string) => path === Routes.Leads.Find,
    },
    {
      icon: (props: SvgIconProps) => <Contacts {...props} />,
      label: 'Clients',
      href: Routes.Leads.MyClients,
      isActive: (path: string) => path === Routes.Leads.MyClients,
    },
    hasSystemX
      ? {
          icon: (props: SvgIconProps) => <RocketLaunch {...props} />,
          label: 'SystemX',
          href: Routes.SystemX,
          isActive: (path: string) => path === Routes.SystemX,
          premium: true,
          hideOnMobile: true,
        }
      : {
          icon: (props: SvgIconProps) => <RocketLaunch {...props} />,
          label: 'Pro',
          href: Routes.Common.Pro,
          isActive: (path: string) => path === Routes.Common.Pro,
          hideOnMobile: true,
        },
    {
      icon: (props: SvgIconProps) => <Settings {...props} />,
      label: 'Compte',
      href: Routes.Account.Settings.OpeningTimes,
      isActive: (path: string) => path.includes(Routes.Account.Settings.Prefix),
    },
    {
      icon: (props: SvgIconProps) => <Help {...props} />,
      label: 'Aide',
      href: Routes.Help.WhatIsAlloClients,
      isActive: (path: string) => path.includes(Routes.Help.Prefix),
    },
  ];
};
